// src/features/tournament/utils/tournament.utils.ts

export const formatMonthKey = (
  date: Date,
): string =>
  `${date.getFullYear()}-${String(
    date.getMonth() + 1,
  ).padStart(
    2,
    '0',
  )}`;


export const parseMonthKey = (
  value: string,
): Date => {
  const [
    year,
    month,
  ] =
    value
      .split('-')
      .map(Number);

  return new Date(
    year,
    month - 1,
    1,
  );
};


export const formatTournamentDate = (
  value: string,
): string => {
  const date =
    new Date(value);

  if (
    Number.isNaN(
      date.getTime(),
    )
  ) {
    return value;
  }

  return new Intl.DateTimeFormat(
    'ko-KR',
    {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    },
  ).format(
    date,
  );
};


export const formatSeed = (
  value:
    | number
    | null
    | undefined,
): string =>
  `${(
    value ?? 0
  ).toLocaleString(
    'ko-KR',
  )} 시드`;